import React from "react";
import { Helmet } from "react-helmet";

import Cta from "../components/cta";
import Header from "../components/header";
import { Container, Section } from "../components/layout";
import PageIntro from "../components/pageIntro";
import HeaderImage from "../images/header-images/tuition-scholarships.jpg";
import HeaderMobile from "../images/header-images/tuition-scholarships-mobile.jpg";
import PiggyBank from "../images/icons/PiggyBank.svg";
import MortarBoard from "../images/icons/MortarBoard.svg";
import Question from "../images/icons/Question.svg";

export default function TuitionAndScholarships() {
  return (
    <div>
      <Helmet htmlAttributes={{lang: 'en'}}>
        <meta charSet="utf-8" />
        <title>
          Tuition and Scholarships - International Viewbook - Maryville
          University
        </title>
      </Helmet>
      <Header image={HeaderImage} mobileImage={HeaderMobile} />
      <Section>
        <Container extraClasses="mb-16">
          <PageIntro
            title="Tuition &amp; Scholarships"
            subtitle="Let's Talk Cost"
            text="We work hard to keep the cost of a quality education affordable. When you consider everything you get at Maryville, we’re an incredible value. Plus, we stand by our commitment to affordability and value by keeping tuition and fees steady year after year. "
          />
        </Container>
        <Container>
          <div className="flex flex-col md:flex-row">
            <div className="text-center px-2 md:px-4 mb-4 md:mb-0 w-full md:w-1/3">
              <div className="flex justify-center mb-2">
                <PiggyBank className="h-16 overflow-visible" />
              </div>
              <p className="text-lg font-bold">Tuition & Fees</p>
              <p className="text-gray">
                Want all the details about Maryville's cost?
              </p>
              <p>
                <a
                  className="text-red underline"
                  href="https://www.maryville.edu/admissions/undergraduate-tuition-and-fees/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Visit Our Website
                </a>
              </p>
            </div>
            <div className="text-center px-2 md:px-4 mb-4 md:mb-0 w-full md:w-1/3">
              <div className="flex justify-center mb-2">
                <MortarBoard className="h-16 overflow-visible" />
              </div>
              <p className="text-lg font-bold">Scholarships</p>
              <p className="text-gray">
                We have plenty of those. Both automatic and competitive.
              </p>
              <p>
                <a
                  className="text-red underline"
                  href="https://www.maryville.edu/admissions/financial-aid/scholarships/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Learn More
                </a>
              </p>
            </div>
            <div className="text-center px-2 md:px-4 mb-4 md:mb-0 w-full md:w-1/3">
              <div className="flex justify-center mb-2">
                <Question className="h-16 overflow-visible" />
              </div>
              <p className="text-lg font-bold">Have Questions?</p>
              <p className="text-gray">
                We're here. Reach out to us at intl@maryville.edu.
              </p>
              <p>
                <a
                  className="text-red underline"
                  href="mailto:intl@maryville.edu "
                >
                  Email Us
                </a>
              </p>
            </div>
          </div>
        </Container>
      </Section>
      <Cta />
    </div>
  );
}
